import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { StoreService } from '../../services/store.service';
import { StoreCategory } from '../../models/storeCategory';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { AddStoreCategoryComponent } from '../store-category/add/add-store-category.component';

@Component({
  selector: 'app-create-store',
  templateUrl: './create-store.component.html',
  styleUrls: ['./create-store.component.css']
})
export class CreateStoreComponent implements OnInit {
  createForm: FormGroup;
  storeCatId: any;
  userId: any;
  storeCategories: StoreCategory[] = [];
  isExist!: boolean;
  constructor(
    public dialogRef: MatDialogRef<CreateStoreComponent>,
    private formBuilder: FormBuilder,
    private storeService: StoreService,
    private loader: LoaderService,
    private notification: NotificationService,
    private dialog: MatDialog,
    private errorhandlerService: ErrorhandlerService
  ) {
    this.createForm = this.formBuilder.group({
      StoreName: ['', Validators.compose([Validators.required])],
      Description: ['', Validators.compose([Validators.required])],
      StoreCategories: [''],
      UserId: [localStorage.getItem('userId')]
    });
  }

  ngOnInit() {
    this.getStoreCategories();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.createForm.controls;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  opentxt() {
  }
  fn_AddCategory() {
    const dialogRef = this.dialog.open(AddStoreCategoryComponent, {
      disableClose: true,
      height: '200px',
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      // If successfully created a category than it will be true, else false
      if (data != null) {
        this.storeCatId = data;
        this.getStoreCategories();
      }
    });
  }

  getStoreCategories() {
    this.userId = localStorage.getItem('userId');
    this.storeService.getStoreCategoriesList(this.userId).subscribe((res: any) => {
      this.storeCategories = res['Data']['ResponseData'];
      this.loader.hide();
    }, (err: any) => {
      this.loader.hide();
      this.dialogRef.close();
      this.errorhandlerService.handleError(err);
    });
  }

  createStore(createForm: FormGroup): void {
    try {
      this.loader.show();
      this.storeService
        .isStoreNameAlreadyExist(this.createForm.controls['StoreName'].value)
        .subscribe(
          (res: any) => {
            if (res.StatusCode === 200 && res.Data.ResponseData) {
              this.notification.error(res.Message, 'Info');
              this.createForm.patchValue({
                StoreName: ''
              });
              this.loader.hide();
              return;
            } else if (res.StatusCode === 404) {
              this.loader.hide();
              // this.notification.error(res.Message, 'error');
              this.storeService.createStore(createForm.value).subscribe((result: any) => {
                if (result.StatusCode === 200) {
                  this.notification.success(result.Message, 'Store');
                  this.loader.hide();
                  this.dialogRef.close();
                } else { this.loader.hide(); }
              });
            }
          },
          (err: any) => {
            this.loader.hide();
            // this.notification.error('An error occured', 'Error');
            this.errorhandlerService.handleError(err);
          }
        );
    } catch (error) {
      this.notification.error('An error occured', 'Error');
      this.loader.hide();
    }
  }

  /** Search store by name */
  fn_searchStore() {
    this.loader.hide();
    return this.fn_getStoreList(this.createForm.controls['StoreName'].value);
  }

  /** Function to get store list */
  fn_getStoreList(storeName: any) {
   
    try {
      this.loader.show();
      this.storeService.isStoreNameAlreadyExist(storeName).subscribe(
        (res: any) => {
          if (res.StatusCode === 200 && res.Data.ResponseData) {
            this.notification.info(res.Message, 'Info');
            this.createForm.patchValue({
              StoreName: ''
            });
            this.loader.hide();
            return;
          } else if (res.StatusCode === 204 || res.StatusCode === 404) {
            this.loader.hide();
          } else {
            this.loader.hide();
          }
        },
        (err: any) => {
          this.loader.hide();
          // this.notification.error('An error occured', 'Error');
          this.errorhandlerService.handleError(err);
        });
    } catch (error) {
      this.loader.hide();
      this.notification.error('An error occured', 'Error');
    }
  }
}
